import { Component, OnInit, Renderer2, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';


@Component({
  standalone: false,
  selector: 'app-cookies-policy-content',
  templateUrl: './cookies-policy.component.html',
  styleUrls: ['./cookies-policy.component.scss']
})
export class CookiesPolicyContentComponent implements OnInit {

  private _renderer2 = inject(Renderer2);
  private _document = inject(DOCUMENT);

  constructor() { }

    public ngOnInit() {

      let script = this._renderer2.createElement('script');
      script.type = `text/javascript`;
      script.id = 'CookieDeclaration';
      script.src = 'https://consent.cookiebot.com/c2d59b52-71f4-443a-bc38-c54fd18501e8/cd.js';
      script.text = ``;

      this._renderer2.appendChild(this._document.body, script);
  }

}
